export enum MakeUIMessages {
	LOAD_MAKES_LIST_ERROR = 'An error occurred while loading the list of Makes.',
	LOAD_MAKE_ERROR = 'An error occurred while loading the list of Makes.',
	ADD_MAKE_SUCCESS = 'Make successfully created.',
	ADD_MAKE_ERROR = 'An error occurred while creating the Make.',
	EDIT_MAKE_SUCCESS = 'Make successfully updated.',
	EDIT_MAKE_ERROR = 'An error occurred while updating the Make.',
	EDIT_MAKES_SUCCESS = 'Makes successfully saved.',
	EDIT_MAKES_ERROR = 'An error occurred while saving the list of Makes.',
}